module.exports = __webpack_public_path__ + "img/iphone.7c6a22e7.png";